import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { ConfigProvider } from '../../providers/config/config';
import { Home2Page } from '../home2/home2';
import { Home3Page } from '../home3/home3';
import { Home4Page } from '../home4/home4';
import { Home5Page } from '../home5/home5';


@Component({
  selector: 'page-renew ',
  templateUrl: 'renew.html',
})
export class RenewPage {
  public slides = [
    { image: "assets/intro/slide-1.png", title: "Your subscription has Ended", description: "If you want to subscribe call here", "line1": "11111111 ","line2": "Some more text" }

  ];

  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public config: ConfigProvider,) {
    this.slides
  }
  openHomePage() {

    if (this.config.homePage == 1) { this.navCtrl.setRoot(HomePage); }
    if (this.config.homePage == 2) { this.navCtrl.setRoot(Home2Page); }
    if (this.config.homePage == 3) { this.navCtrl.setRoot(Home3Page); }
    if (this.config.homePage == 4) { this.navCtrl.setRoot(Home4Page); }
    if (this.config.homePage == 5) { this.navCtrl.setRoot(Home5Page); }
  }
}



// WEBPACK FOOTER //
// ./src/pages/renew_sub/renew.ts